import React from 'react';
interface ButtonProps {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  href,
  className = '',
  fullWidth = false
}: ButtonProps) {
  const sharedClasses = `
    relative inline-flex items-center justify-center px-8 py-4 
    text-lg font-bold text-white transition-all duration-300 
    bg-amber-500 rounded-full shadow-lg hover:bg-amber-600 
    hover:shadow-amber-500/30 hover:-translate-y-1
    focus:outline-none focus:ring-4 focus:ring-amber-500/50
    ${fullWidth ? 'w-full' : ''}
    ${className}
  `;
  const sharedStyle = {
    animation: 'pulse-subtle 2s infinite'
  };
  if (href) {
    return <a href={href} target="_blank" rel="noopener noreferrer" className={sharedClasses} style={sharedStyle} data-id="element-14">
        {children}
      </a>;
  }
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      const target = document.getElementById('offer-card');
      if (target) {
        const rect = target.getBoundingClientRect();
        const cardCenter = rect.top + window.scrollY + rect.height / 2;
        const y = cardCenter - window.innerHeight / 2;
        window.scrollTo({
          top: Math.max(0, y),
          behavior: 'smooth'
        });
      }
    }
  };
  return <button onClick={handleClick} className={sharedClasses} style={sharedStyle} data-id="element-15">
      {children}
    </button>;
}